import { OnInit, AfterViewInit, Input, EventEmitter, Output, ChangeDetectorRef } from "@angular/core";
import { ViewerModel } from "../../../models/viewer-model";
import { E5ConfigurationService } from "e5core-angular-services";
import { ViewerBehaviourType } from "../../../enums/viewer-behaviour-type";
import { ViewerDisplayEvent } from "../../../events/viewer-display-event";

export class E5coreUiAttachmentViewerBaseComponent implements AfterViewInit, OnInit {
    @Input() behaviourType : ViewerBehaviourType;
    @Input() popupWindowFeatures : string;
    @Input() readonly : boolean;
    @Output() viewerDisplayedEvent = new EventEmitter<ViewerDisplayEvent>();

    attachmentUrl : string;

    constructor(public e5ConfigurationService : E5ConfigurationService, public changeDetectorRef: ChangeDetectorRef) 
    {
    }

    ngOnInit() {
    }
      
    ngAfterViewInit() {
    }

    public showInlineViewer(viewerModel : ViewerModel) {
        this.constructViewerUrl(viewerModel, null);
        this.raiseEvent(viewerModel);
    }

    public showPopViewer(viewerModel : ViewerModel) {
        this.constructViewerUrl(viewerModel, (vm, url) => this.performWindowPopup(vm, url));
    }

    public performWindowPopup(viewerModel : ViewerModel, attachmentUrl : string) {
        window.open(attachmentUrl, "E5AttachmentViewer", this.popupWindowFeatures);
        this.raiseEvent(viewerModel);
    }

    public constructViewerUrl(viewerModel : ViewerModel, nextFunction : Function) : void {
    }

    public raiseEvent(viewerModel : ViewerModel) : void {
    }
}